export const isSlotsCountLoading = (state) => state.slotsCountLoading;
export { default as default } from './reducers';
